import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useTealiumEventProperties, useTrackPageView } from '@grandvisionhq/svc-tealium/events';

const usePageViewAccountWishlistEvent = (wishlistData, wishlistLoading)=>{
    const { commonEventProperties , getCommonUserProperties  } = useTealiumEventProperties();
    const accountWishlistPageView = React.useCallback(()=>{
        return new Promise(function() {
            var _ref = swcHelpers.asyncToGenerator(function*(resolve) {
                if (wishlistLoading) return;
                const commonUserProperties = yield getCommonUserProperties();
                if (!commonUserProperties) return;
                resolve(swcHelpers.objectSpread({}, commonEventProperties, commonUserProperties, {
                    id: 'VirtualPage-View',
                    Page_Type: 'Wishlist',
                    Page_Section1: 'Account',
                    Page_Design: (wishlistData === null || wishlistData === void 0 ? void 0 : wishlistData.items.length) ? undefined : 'Empty'
                }));
            });
            return function(resolve) {
                return _ref.apply(this, arguments);
            };
        }());
    }, [
        getCommonUserProperties,
        wishlistLoading,
        commonEventProperties,
        wishlistData === null || wishlistData === void 0 ? void 0 : wishlistData.items.length
    ]);
    useTrackPageView(accountWishlistPageView);
};

export { usePageViewAccountWishlistEvent };
//# sourceMappingURL=use-pageview-account-wishlist-event.js.map
